import { I18n } from "./i18n";

export const i18nEs: I18n = {
  unsupportedBrowser: "Tu versión de navegador no está soportada. Actualiza tu navegador a la versión más reciente o prueba otro.",
  videoDeleted: "Lo sentimos, este video ya no está disponible.",
  videoInPreparation: "El video estará disponible en breve.<br/>¡Carga la página de nuevo en unos instantes!",

  sendReport: "Enviar el informe",
  thankYouForSendingReport: "Gracias por tu solicitud.",
  configurationParsingFailure: "La configuracón del reproductor incorrecta.",
  resourceLoadingFailure: "Se produjo un error en la carga de los elementos del vídeo",
  playbackFailure: "Se produjo un error",
  runtimeError: "Se produjo un error",

  subtitles: "Subtítulos",
  part: "Parte",
  play: "Reproducir",
  pause: "Pausa",
  replay: "Ver de nuevo",
  mute: "Silenciar",
  unmute: "Activar sonido",
  share: "Compartir",
  fullscreen: "Pantalla completa",
  exitFullscreen: "Salir de modo de pantalla completa",
  poweredByVintom: "Powered by Vintom",
  licenceAdditionalText: "Read",
  licenceLabel: "player licence",
  linkLicence: "https://player2.vintom.com/player/Vintom_player_terms_of_use.pdf",

  bandwidth: "Ancho de banda",
  mbps: "Mbps",

  facebook: "Facebook",
  twitter: "Twitter",

  videoInPreparationLoadingPage: "La película aún no está lista. <br>Intenta volver a cargar la página más tarde",
};
